import React, { useContext, useEffect } from "react";
import { ReactSession } from "react-client-session";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../header/Header";
import Sidebar from "../supervisor_home/sidebar/Sidebar";
import OtherSidebar from '../operator_home/sidebar/Sidebar';
import FormContext from "../../context/FormContext";
import ManualEntryTableContainer from "../manual_table_view/ManualEntryTableContainer";

import "./ManualEntry.css";

const ManualEntryView = () => {
  const role = ReactSession.get("role")
  const location = useLocation()

  return (
    <div className="manual-entry-container">
      <Header />
      {role =='2' ? <Sidebar className="sidebar-operator-home" /> : <OtherSidebar className="sidebar-operator-home"/>}
      <ManualEntryTableContainer />
    </div>
  );
};

export default ManualEntryView;
